<template>
  <div>
    <div class="ctn">
      <div ref="main-text" class="main-text" :class="{'main-text--centered' : didResetMainTextTransformProperty}">
        <div ref="title" class="main-text__title">
          <clip-text :is-visible="isTitleVisible">
            Olá
          </clip-text>
        </div>
        <div ref="name" class="main-text__name">
          <clip-text :is-visible="isNameVisible">
            Me chamo Lucas
          </clip-text>
        </div>
        <div ref="front-end" class="main-text__skill">
          <clip-text :is-visible="isFrontEndSkillVisible">
            Sou desenvolvedor front-end,
          </clip-text>
        </div>
        <div ref="designer" class="main-text__skill flex">
          <clip-text :is-visible="isDesignerSkillVisible">
            designer gráfico
          </clip-text>
          <clip-text :is-visible="isUiUxSkillVisible" class="ml-1">
            e de UI/UX
          </clip-text>
        </div>
        <div ref="location" class="main-text__location">
          <clip-text :is-visible="isStateVisible">
            Do Ceará,
          </clip-text>
          <clip-text :is-visible="isCountryVisible" class="ml-1">
            Brasil.
          </clip-text>
        </div>
        <div ref="buttons" class="action-btns">
          <main-btn
            bordered
            :small="isMobile"
            label="Contato"
            class="action-btn action-btn--1"
            :class="{'action-btn--visible' : hasIntroAnimFinished}"
            @click="openContactMenu"
          />
          <main-btn
            bordered
            :small="isMobile"
            label="Trabalhos"
            class="action-btn action-btn--2"
            :class="{'action-btn--visible' : hasIntroAnimFinished}"
            @click="goToPortfolio"
          />
        </div>
      </div>
      <transition name="welcome-bg">
        <welcome-background-text
          v-if="isTitleVisible && !isNameVisible"
          :visible="isTitleVisible"
        />
      </transition>
    </div>
    <div
      v-if="isImagesBackgroundContainerVisible"
      class="bg-text-wrapper"
      :class="{'bg-text-wrapper--visible' : isBackgroundTextVisible}"
    >
      <background
        :selected-preview="index"
      >
        <front-end-background v-if="isFrontEndBackgroundInDOM" />
        <graphic-designer-background v-if="isGraphicDesignBackgroundInDOM" />
        <ui-ux-background v-if="isUiUxBackgroundInDOM" />
        <state-background v-if="isStateBackgroundInDOM" />
        <country-background v-if="isCountryBackgroundInDOM" />
      </background>
    </div>
  </div>
</template>

<script>
import ClipText from '@/components/clip-text'
import { gsap } from 'gsap'
import { mapState } from 'vuex'
import WelcomeBackgroundText from '@/components/backgrounds/welcome-background-text'
import FrontEndBackground from '@/components/backgrounds/front-end-background'
import GraphicDesignerBackground from '@/components/backgrounds/graphic-designer-background'
import UiUxBackground from '@/components/backgrounds/ui-ux-background'
import Background from '@/components/background'
import StateBackground from '@/components/backgrounds/state-background'
import CountryBackground from '@/components/backgrounds/country-background'

const MOBILE_BROWSER_OMNIBAR_HEIGHT = 80
const APP_LOAD_WAIT_TIME = 500 // Necessary to make sure the user will see the initial animation

export default {
  name: 'Intro',
  components: {
    CountryBackground,
    StateBackground,
    ClipText,
    WelcomeBackgroundText,
    FrontEndBackground,
    GraphicDesignerBackground,
    UiUxBackground,
    Background
  },
  data () {
    return {
      index: 0,
      isImagesBackgroundContainerVisible: true,
      isFrontEndBackgroundInDOM: true,
      isGraphicDesignBackgroundInDOM: true,
      isUiUxBackgroundInDOM: false,
      isStateBackgroundInDOM: false,
      isCountryBackgroundInDOM: false,
      isBackgroundTextVisible: false,
      introTl: undefined,
      mainTextTl: undefined,
      isWelcomeBgVisible: false,
      isTitleVisible: false,
      isNameVisible: false,
      isFrontEndSkillVisible: false,
      isDesignerSkillVisible: false,
      isUiUxSkillVisible: false,
      isUxSkillVisible: false,
      isStateVisible: false,
      isCountryVisible: false,
      hasIntroAnimFinished: false,
      isSkipToolTipVisible: false,
      didResetMainTextTransformProperty: false
    }
  },
  computed: {
    ...mapState(['vHeight', 'previousVHeight', 'didAlreadySeeIntroAnim', 'isMobile', 'didAlreadyWatchIntroAnimInSection'])
  },
  methods: {
    finishIntroAnimation (shouldResetTransformProperty) {
      if (this.introTl) {
        this.introTl.kill()
        this.mainTextTl.kill()
      }
      this.isImagesBackgroundContainerVisible = false
      this.setTextContentToVisible()
      this.hasIntroAnimFinished = true
      this.isSkipToolTipVisible = false
      this.$store.dispatch(this.$SET_DID_SEE_INTRO_ANIM)
      this.$store.dispatch(this.$SET_DID_WATCH_INTRO_ANIM_IN_SECTION)
      this.$store.dispatch(this.$CHANGE_CURSOR_STATE, 'default')

      if (shouldResetTransformProperty) {
        this.resetMainTextTransformProperty(true)
      }
    },
    setTextContentToVisible () {
      this.isWelcomeBgVisible = true
      this.isTitleVisible = true
      this.isNameVisible = true
      this.isFrontEndSkillVisible = true
      this.isDesignerSkillVisible = true
      this.isUiUxSkillVisible = true
      this.isUxSkillVisible = true
      this.isStateVisible = true
      this.isCountryVisible = true
    },
    goToPortfolio () {
      this.$router.push({ name: 'portfolio' })
    },
    removeKeyboardEventListener () {
      document.body.onkeyup = undefined
    },
    checkIfDidSeeIntroAnimation () {
      if (this.didAlreadySeeIntroAnim) {
        this.$root.$emit('show-tooltip', {
          icon: 'forward',
          title: 'Olá de novo!',
          text: this.isMobile
            ? 'Você pode avançar a introdução tocando aqui.'
            : 'Você pode avançar a introdução pressionando espaço ou clicando aqui.',
          time: 16000
        })
        document.body.onkeyup = (e) => {
          if (e.code === 'Space') {
            this.$root.$emit('force-dismiss-tooltip')
            this.finishIntroAnimation(true)
            this.removeKeyboardEventListener()
          }
        }
      }
    },
    resetMainTextTransformProperty (shouldFadeInOut) {
      if (shouldFadeInOut) {
        const mainText = this.$refs['main-text']
        const OPACITY_TRANSITION_TIME = 300
        mainText.style.opacity = '0'
        setTimeout(() => {
          this.didResetMainTextTransformProperty = true
          mainText.style.transform = ''
          mainText.style.opacity = ''
        }, OPACITY_TRANSITION_TIME)
      } else this.didResetMainTextTransformProperty = true
    },
    openContactMenu () {
      this.$store.dispatch(this.$SET_TOGGLE_CONTACT_MODAL_OPEN)
    },
    animateMainTextContainer () {
      const mainText = this.$refs['main-text']
      const titleHeight = this.$refs.title.getBoundingClientRect().height.toFixed(3)
      const nameHeight = this.$refs.name.getBoundingClientRect().height.toFixed(3)
      const frontEndHeight = this.$refs['front-end'].getBoundingClientRect().height.toFixed(3)
      const designerHeight = this.$refs.designer.getBoundingClientRect().height.toFixed(3)
      const locationHeight = this.$refs.location.getBoundingClientRect().height.toFixed(3)
      const buttonsHeight = this.$refs.buttons.getBoundingClientRect().height.toFixed(3)
      mainText.style.transform = `translateY(${this.vHeight / 2 - titleHeight / 2}px)`
      this.mainTextTl = gsap.timeline()
        .to(mainText, 0, {
          onStart: () => {
            this.isTitleVisible = true
            this.$root.$emit('display-welcome-background')
            this.checkIfDidSeeIntroAnimation()
          }
        }, 'hi')
        .to(mainText, 0.5, {
          y: `-=${nameHeight / 2}`
        }, 'hi+=2')
        .to(mainText, 0.5, {
          y: `-=${frontEndHeight / 2}`
        }, 'hi+=4')
        .to(mainText, 0.5, {
          y: `-=${designerHeight / 2}`
        }, 'hi+=6')
        .to(mainText, 0.5, {
        }, 'hi+=8')
        .to(mainText, 0.5, {
          y: `-=${locationHeight / 2 + 96 / 2}`
        }, 'hi+=11')
        .to(mainText, 0.5, {
        }, 'hi+=13')
        .to(mainText, 0.5, {
          y: `-=${buttonsHeight / 2}`
        }, 'hi+=16')
    },
    animateMainTextContent () {
      const mainText = this.$refs['main-text']
      const titleHeight = this.$refs.title.getBoundingClientRect().height.toFixed(3)
      mainText.style.transform = `translateY(${this.vHeight / 2 - titleHeight / 2}px)`
      this.introTl = gsap.timeline()
        .to(mainText, 0, {
          onStart: () => {
            this.isTitleVisible = true
            this.$root.$emit('display-welcome-background')
            this.checkIfDidSeeIntroAnimation()
          }
        }, 'hi')
        .to(mainText, 0.5, {
          onStart: () => {
            this.isNameVisible = true
            this.isBackgroundTextVisible = true
          }
        }, 'hi+=2')
        .to(mainText, 0.5, {
          onStart: () => {
            this.isFrontEndSkillVisible = true
            this.$root.$emit('display-front-end-background')
            this.index += 1
          }
        }, 'hi+=4')
        .to(mainText, 0.5, {
          onStart: () => {
            this.isFrontEndBackgroundInDOM = false
            this.isUiUxBackgroundInDOM = true
            this.isDesignerSkillVisible = true
            this.$root.$emit('display-graphic-designer-background')
            this.index += 1
          }
        }, 'hi+=6')
        .to(mainText, 0.5, {
          onStart: () => {
            this.isUiUxSkillVisible = true
            this.isStateBackgroundInDOM = true
            this.$root.$emit('display-ui-ux-background')
            this.index += 1
          }
        }, 'hi+=8')
        .to(mainText, 0.5, {
          onStart: () => {
            this.isUiUxBackgroundInDOM = false
            this.isStateVisible = true
            this.isCountryBackgroundInDOM = true
            this.$root.$emit('display-state-background')
            this.index += 1
          }
        }, 'hi+=11')
        .to(mainText, 0.5, {
          onStart: () => {
            this.isCountryVisible = true
            this.isStateBackgroundInDOM = false
            this.$root.$emit('display-country-background')
            this.index += 1
          }
        }, 'hi+=13')
        .to(mainText, 0.5, {
          onStart: () => {
            this.isCountryBackgroundInDOM = false
          },
          onComplete: () => {
            this.finishIntroAnimation()
          }
        }, 'hi+=16')
    }
  },
  mounted () {
    if (this.didAlreadyWatchIntroAnimInSection) this.finishIntroAnimation(true)
    else {
      const mainText = this.$refs['main-text']

      setTimeout(() => {
        this.animateMainTextContent()
        this.animateMainTextContainer()
      }, APP_LOAD_WAIT_TIME)

      this.$root.$on('resize', () => {
        let vHeightOffset = this.vHeight - this.previousVHeight
        if (vHeightOffset < 0) vHeightOffset = vHeightOffset * -1
        if (vHeightOffset > MOBILE_BROWSER_OMNIBAR_HEIGHT) {
          this.mainTextTl.kill()
          gsap.set(mainText, { clearProps: 'all' })
          this.resetMainTextTransformProperty()
        }
      })
      this.$root.$on('dismiss-tooltip', () => {
        this.finishIntroAnimation(true)
        this.removeKeyboardEventListener()
      })
    }
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.bg-text-wrapper
  @apply absolute pin-t pin-l opacity-0 w-full h-full
  transition: opacity .3s
  &--visible
    @apply opacity-100

.ctn
  @apply fixed z-10 flex items-start justify-center w-full h-screen
  &--centered
    @apply items-center

.main-text
  @apply font-sans
  transition: opacity .2s
  @screen xl
    width: 35rem
  &__title
    @apply text-7xl
    @screen sm-l
      @apply text-6xl
    @screen xl
      @apply text-8xl
  &__name
    @apply text-4xl
    @screen xl
      @apply text-6xl
  &__skill
    @apply text-2xl
    @screen xl
      @apply text-4xl
  &__location
    @apply flex text-4xl mt-3
    @screen sm-l
      @apply text-3xl mt-2
    @screen lg
      @apply mt-5
  &--centered
    @apply flex flex-col justify-center h-full

.welcome-bg
  &-leave-to
    @apply opacity-0
  &-leave-active
    transition: opacity .3s

.action-btn
  @apply relative opacity-0 pointer-events-none w-40
  font-size: 1.3rem !important
  transition: opacity .4s
  transform: translateY(30px)
  @screen md
    @apply w-48
    font-size: 1.5rem !important
  &--1
    transition-delay: .1s
    @screen md
      left: -40px
    @screen xl
      left: initial
  &--2
    transition-delay: .2s
    @screen md
      right: -40px
    @screen xl
      right: initial
  &--visible
    @apply opacity-100 translate-y-0 pointer-events-auto

.action-btns
  @apply flex justify-between mt-6
  @screen sm-l
    @apply mt-3
</style>
